import { useState, useEffect, useCallback } from "react";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import ivy_logo from "@/assets/ivy_logo.png";
import harmony_logo from "@/assets/harmonylogo.svg";
import { actionCreators as ParentCreators } from "@/store/Parent";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import $ from "jquery";
import Swal from "sweetalert2";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const jwt = useSelector((state: any) => state.Parent.jwt);
  const loginloading = useSelector((state: any) => state.Parent.loginloading);
  const loginerror = useSelector((state: any) => state.Parent.loginerror);

  const onSubmit = useCallback(
    (e: any) => {
      e.preventDefault();
      dispatch(ParentCreators.Login({ userName, password }));
    },
    [dispatch, password, userName],
  );

  const onCancel = useCallback(() => {
    dispatch(ParentCreators.ClearParent());
    dispatch(ParentCreators.ClearJwt());
  }, [dispatch]);

  useEffect(() => {
    $("preloader").hide();
    // dispatch(ParentCreators.ClearJwt());
  }, []);

  useEffect(() => {
    if (jwt) {
      navigate("/dashboard");
    }
  }, [jwt, navigate]);

  useEffect(() => {
    if (loginerror) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: loginerror,
      }).then(() => {
        onCancel();
      });
    }
  }, [loginerror, onCancel]);

  return (
    <div
      className="d-flex align-items-center justify-content-center px-3 py-5"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #eef4fa 0%, #dbe8f4 100%)",
      }}
    >
      <div
        className="card border-0 shadow-lg overflow-hidden w-100 "
        style={{ maxWidth: 920, borderRadius: 20 }}
      >
        <div className="row g-0">
          <div
            className="col-md-5 bg-ivy-dark d-flex flex-column align-items-center justify-content-center text-center text-white p-5"
            style={{
              backgroundImage:
                "linear-gradient(160deg, #0569b8 0%, #03589b 55%, #023f70 100%)",
            }}
          >
            <img
              src={ivy_logo}
              alt="IVY International School"
              style={{ height: 130, width: "auto" }}
            />
            <img
              src={harmony_logo}
              alt="Harmony"
              className="mt-4"
              style={{ height: 36, width: "auto" }}
            />
            <div
              className="mt-4 mb-3"
              style={{
                width: 48,
                height: 3,
                borderRadius: 2,
                backgroundColor: "#ffbd30",
              }}
            />
            <p className="mb-0" style={{ opacity: 0.85, fontSize: "0.95rem" }}>
              Parent Portal
            </p>
          </div>

          <div className="col-md-7 bg-white p-4 p-sm-5 d-flex flex-column justify-content-center">
            <h1 className="h3 fw-bold mb-1" style={{ color: "#03589b" }}>
              Welcome back
            </h1>
            <p className="text-muted mb-4">
              Sign in to continue to your account.
            </p>

            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label
                  htmlFor="input_email"
                  className="form-label fw-semibold small text-secondary"
                >
                  Email address
                </label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text bg-light border-end-0 text-secondary">
                    <FiMail />
                  </span>
                  <input
                    id="input_email"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    required={true}
                    maxLength={100}
                    type="email"
                    autoComplete="username"
                    autoFocus
                    className="form-control bg-light border-start-0 text-black"
                    style={{ fontSize: "1rem" }}
                    placeholder="name@example.com"
                  />
                </div>
              </div>

              <div className="mb-2">
                <label
                  htmlFor="input_password"
                  className="form-label fw-semibold small text-secondary"
                >
                  Password
                </label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text bg-light border-end-0 text-secondary">
                    <FiLock />
                  </span>
                  <input
                    id="input_password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required={true}
                    maxLength={100}
                    autoComplete="current-password"
                    placeholder="Enter your password"
                    className="form-control bg-light border-start-0 border-end-0 text-black"
                    style={{ fontSize: "1rem" }}
                  />
                  <button
                    type="button"
                    className="input-group-text bg-light border-start-0 text-secondary"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div className="text-end mb-4">
                <NavLink
                  to={"/GenerateCode"}
                  className="small fw-semibold text-decoration-none"
                  style={{ color: "#03589b" }}
                >
                  Forgot your password?
                </NavLink>
              </div>

              <button
                type="submit"
                disabled={loginloading}
                className="btn btn-warning btn-lg w-100 text-white fw-semibold shadow-sm"
                style={{
                  backgroundColor: "#ffbd30",
                  borderColor: "#ffbd30",
                  borderRadius: 10,
                  ...(loginloading && { cursor: "wait", pointerEvents: "auto" }),
                }}
              >
                {loginloading ? (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    aria-hidden="true"
                  />
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
